"use client"

import { useEffect, useState } from "react"
import { createPortal } from "react-dom"

/**
 * Renders children into the `#page-bottom-slot` div that LayoutWrapper places
 * AFTER the site footer — the last thing on the page.
 *
 * Pages are server components and the footer lives in the client LayoutWrapper,
 * so there's no server-side way to compose past it. This renders in place on the
 * server (keeping the content in the crawlable/no-JS HTML, which matters for
 * image attribution) and relocates it below the footer once mounted. The
 * two-pass mount is deliberate: portaling on the first client render would not
 * match the server HTML and would throw a hydration mismatch.
 */
export function PageBottomPortal({ children }: { children: React.ReactNode }) {
  const [slot, setSlot] = useState<HTMLElement | null>(null)

  useEffect(() => {
    setSlot(document.getElementById("page-bottom-slot"))
  }, [])

  if (!slot) return <>{children}</>
  return createPortal(children, slot)
}
